import React, {useRef, useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import Check from '../icons-af/check';
import {get, post} from '../../services/artfinder-service';
import useModal from '../../hooks/use-modal/use-modal';
import {on, off, emit, emitFactory} from '../../utils/events';
import constantsFactory from '../../utils/constants';
import Loading from '../loading/loading';
import useTranslation from '../../hooks/use-translation/use-translation';
import Button from '../button/button';
import {H5, P} from '../typography/typography';
const {EVENTS} = constantsFactory();
import {addToCollection, removeFromCollection} from '../../../redux/actions/productActions';
import './modal-add-to-collection.scss';

const ModalAddToCollection = () => {
  const target = useRef(null);
  const modal = useModal(target);
  const [collections, setCollections]: any = useState([]);
  const [product, setProduct]: any = useState({});
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const fetchAndSetCollections = (productSlug) => {
    setLoading(true);
    get(`/collections/api/product-collections/${productSlug}/`)
      .then(setCollections)
      .catch((err) => {
        console.log('product collections fetch error', err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onModalOpen = (product) => {
    setProduct(product);
    modal.open();
    fetchAndSetCollections(product.slug);
  };

  useEffect(() => {
    on(EVENTS.CLICK_ADD_TO_COLLECTION, onModalOpen);
    on(EVENTS.CLICK_CREATE_NEW_COLLECTION, modal.close);

    return () => {
      off(EVENTS.CLICK_ADD_TO_COLLECTION, onModalOpen);
      off(EVENTS.CLICK_CREATE_NEW_COLLECTION, modal.close);
      modal.destroy();
    };
  }, [modal]);

  const handleClick = (collection) => () => {
    post('/collections/api/', {
      product_id: product.id,
      action: collection.is_product_in_collection ? 'remove' : 'add',
      collection_id: collection.id,
    })
      .then(() => {
        collection.is_product_in_collection
          ? dispatch(removeFromCollection(collection.id))
          : dispatch(addToCollection(collection.id));
        fetchAndSetCollections(product.slug);
        emit('PRODUCT_ADDED_TO_COLLECTION');
      })
      .catch((err) => {
        console.log('add to collection error: ', err);
      });
  };

  return (
    <div
      ref={target}
      className="modal fade modal-add-to-collection"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <H5 style="art">{t('Add to collection')}</H5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            {loading && <Loading />}
            <div className="list-group">
              {collections.map((x) => (
                <button
                  key={x.id}
                  type="button"
                  className="list-group-item list-group-item-action"
                  onClick={handleClick(x)}
                >
                  <img
                    loading="lazy"
                    height="51px"
                    width="51px"
                    src={
                      x.is_product_in_collection
                        ? product.main_image_url
                        : 'https://d2m7ibezl7l5lt.cloudfront.net/img/icons/collection-default.png'
                    }
                    alt={x.is_product_in_collection ? product.name : t('mountain landscape')}
                  />
                  <div>
                    <H5 style="p1-b">{x.name}</H5>
                    <P style="p1">{t('{total_items} artworks', x)}</P>
                  </div>
                  {x.is_product_in_collection && <Check height="51px" width="28px" />}
                </button>
              ))}
            </div>
          </div>
          <div className="modal-footer">
            <Button onClick={emitFactory('CLICK_CREATE_NEW_COLLECTION')}>
              Create a new collection
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAddToCollection;
